import { useCallback, useEffect, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { PublicationDrawerContext } from './publicationDrawerContext';
import { PublicationDrawer } from './PublicationDrawer';

/** Owns the single app-wide publication quick-view drawer. */
export const PublicationDrawerProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [publicationId, setPublicationId] = useState<number | null>(null);
  const { pathname } = useLocation();

  const open = useCallback((id: number) => setPublicationId(id), []);
  const close = useCallback(() => setPublicationId(null), []);

  // Leaving the page (incl. "open full view") dismisses the quick view.
  useEffect(() => {
    setPublicationId(null);
  }, [pathname]);

  const value = useMemo(() => ({ open, close }), [open, close]);

  return (
    <PublicationDrawerContext.Provider value={value}>
      {children}
      <PublicationDrawer publicationId={publicationId} onClose={close} />
    </PublicationDrawerContext.Provider>
  );
};
